export const vFocus = {
  mounted: (el: HTMLFormElement) => {
    el.select();
  },
};
